export enum EnvironmentEnum {
  PROD = "prod",
  TEST = "test",
  DEMO = "demo",
  LOCAL = "local"
}
